export default function DonePage() {
  return (
    <div className="flex min-h-[240px] items-center justify-center rounded border border-solid border-border bg-white p-6">
      <p className="text-sm text-sub">完了したリクエストです。</p>
    </div>
  );
}
